const buildDocumentHTML = ({ headerHtml = "", contentHtml = "", styles = "" } = {}) => `
  <div class="siis-pdf-root">
    <style>${styles}</style>
    <section class="siis-pdf-source" data-pdf-part="source">
      <section class="siis-pdf-source__header" data-pdf-part="header">
        ${headerHtml}
      </section>
      <section class="siis-pdf-content" data-pdf-part="content">
        ${contentHtml}
      </section>
    </section>
    <section class="siis-pdf-pages" data-pdf-part="pages"></section>
  </div>
`;

export { buildDocumentHTML };
export default buildDocumentHTML;
